/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelBarterEntity } from './parcelBarterEntity.model';


export interface BarterParcelDo { 
    errorHidden: boolean;
    invalidNotUsed?: boolean;
    invalidOutdated?: boolean;
    invalidUsed?: boolean;
    originalOwned?: boolean;
    originalRented?: boolean;
    originalSubrented?: boolean;
    parcel?: ParcelBarterEntity;
    parcelNoFurtherRent?: boolean;
    parcelOnOtherProposalBarter?: boolean;
    parcelOnOtherValidBarter?: boolean;
    parcelOutdated?: boolean;
    parcelOutsideLpisBlocks?: boolean;
}

